import { useLazyQuery } from "@apollo/client";
import { userQuizState } from "atoms/userQuiz";
import PageLoader from "components/Layout/PageLoader";
import { GET_QUIZ_WITH_RESULT } from "graphql/quiz";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import Content from "./Content";
import { toNumber } from "lodash";

export interface AnalayzeProps {}

const Analayze: React.FC<AnalayzeProps> = () => {
  const userQuiz = useRecoilValue(userQuizState);
  const getQueryStringValue = (key: string) => {
    return decodeURIComponent(
      window.location.search.replace(
        new RegExp(
          "^(?:.*[&\\?]" +
            encodeURIComponent(key).replace(/[*]/g, "\\$&") +
            "(?:\\=([^&]*))?)?.*$",
          "i"
        ),
        "$1"
      )
    );
  };

  const quizID = getQueryStringValue("qi");
  const quizToken = getQueryStringValue("qt");

  const finalHeader =
    quizToken === "null" || quizToken.length === 0
      ? {}
      : {
          "access-token": quizToken,
        };

  const [getQuiz, { loading, error, data }] = useLazyQuery(
    GET_QUIZ_WITH_RESULT,
    {
      context: {
        headers: finalHeader,
      },
      notifyOnNetworkStatusChange: true,
    }
  );

  useEffect(() => {
    if (quizID || quizToken) {
      getQuiz({
        variables: {
          quiz_id: toNumber(quizID),
        },
      });
    }
  }, [quizID, quizToken, getQuiz]);

  if (quizToken || quizID) {
    return (
      <PageLoader loading={loading} error={error} onRefresh={getQuiz}>
        {data && <Content result={data.get_quiz.result} />}
      </PageLoader>
    );
  }

  return <Content result={userQuiz?.result} />;
};

export default Analayze;
